import { useState, useEffect, useRef } from 'react';
import { FaTimesCircle } from 'react-icons/fa';
import { animated, easings, useSpring } from '@react-spring/web';

const CompactContentNode = ({ title, onOpen, children, direction, style }) => {
  let directionStyle;
  switch (direction) {
    case 'up':
      directionStyle = { left: 0, bottom: 40 };
      break;

    case 'down-right':
      directionStyle = { right: 0, top: 40 };
      break;

    default:
    case 'down':
      directionStyle = { left: 0, top: 40 };
      break;
  }

  return (
    <div
      style={{
        border: '1px solid #ccc',
        position: 'absolute',
        maxHeight: '60vh',
        overflowY: 'scroll',
        zIndex: 1000,
        background: 'white',
        borderRadius: 4,
        padding: '15px',
        boxShadow: `3px 4px 6px rgba(0,0,0,.1)`,
        ...directionStyle,
        ...(style || {}),
      }}
    >
      <div
        style={{ cursor: 'pointer', color: '#555', position: 'absolute', top: 10, right: 10, zIndex: 100 }}
        onClick={() => onOpen(false)}
      >
        <FaTimesCircle size={18} />
      </div>
      <div style={{ position: 'relative' }}>{children}</div>
    </div>
  );
};

const ContentNode = ({ title, onOpen, children }) => {
  const springs = useSpring({
    from: {
      opacity: 0.5,
      transform: 'scale(1, 0.5)',
      y: -100,
    },
    to: {
      opacity: 1,
      transform: 'scale(1, 1)',
      y: 0,
    },
    config: {
      duration: 250,
      easing: easings.easeOutBack,
    },
  });

  return (
    <>
      <style>
        {`
          @keyframes enter {
            0% {
              opacity: 0;
              transform: translateY(-200px) scaleY(0.8);
            }
            60% {
              opacity: 1;
              transform: translateY(0) scaleY(1.05);
            }
            100% {
              opacity: 1;
              transform: translateY(0) scaleY(1);
            }
          }
        `}
      </style>

      <div
        style={{
          position: 'fixed',
          left: 0,
          top: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(255,255,255,0.8)',
          zIndex: 10000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        onClick={() => onOpen(false)}
      >
        <div
          style={{
            border: '1px solid #ccc',
            margin: 10,
            padding: 16,
            zIndex: 1000,
            background: 'white',
            borderRadius: 8,
            position: 'absolute',
            top: 80,
            maxHeight: '80vh',
            maxWidth: '90vw',
            transformOrigin: 'top center',
            animation: 'enter 0.3s ease-out 1 forwards',
            overflow: 'scroll',
          }}
          onWheel={(e) => e.stopPropagation()}
          onClick={(e) => e.stopPropagation()}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <div style={{ color: '#555', fontWeight: 'bold' }}>{title}</div>
            <div style={{ cursor: 'pointer', color: '#555' }} onClick={() => onOpen(false)}>
              <FaTimesCircle size={18} />
            </div>
          </div>
          {children}
        </div>
      </div>
    </>
  );
};

export const Modal = ({ children, title, compact, startOpen, close, direction, style }) => {
  const [open, setOpen] = useState(startOpen);

  useEffect(() => {
    if (close) {
      setOpen(false);
    }
  }, [close]);

  const openNode = (
    <div style={{ cursor: 'pointer' }} onClick={() => setOpen(!open)}>
      {children[0]}
    </div>
  );

  return (
    <div style={{ position: 'relative' }}>
      {openNode}

      {open && compact && (
        <CompactContentNode title={title} onOpen={setOpen} direction={direction || 'down'} style={style}>
          {children[1]}
        </CompactContentNode>
      )}
      {open && !compact && (
        <ContentNode title={title} onOpen={setOpen}>
          {children[1]}
        </ContentNode>
      )}
    </div>
  );
};
